export enum EOperationErrorCause {
  LIMITS_EXCEEDED = 'LIMITS_EXCEEDED',
  PAYMENT_NOT_STARTED = 'PAYMENT_NOT_STARTED',
  NO_OFFERS_AVAILABLE = 'NO_OFFERS_AVAILABLE',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
}
